export const validateMissingParam = (paramName, value) => {
  if (!value) {
    throw new Error(`Missing ${paramName} param. Given ${value}.`);
  }
};

export const isSalesChatEnvironmentValid = (environment) => ['development', 'production'].includes(environment);

